import { render } from "./AppTableController.vue?vue&type=template&id=69e77f2f&ts=true"
import script from "./AppTableController.vue?vue&type=script&lang=ts"
export * from "./AppTableController.vue?vue&type=script&lang=ts"

import "./AppTableController.vue?vue&type=style&index=0&id=69e77f2f&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__